import React from 'react'
import "./separator.css"

const Separator = () => {
    return (
        <div className="separator">
            
        </div>
    )
}

export default Separator
